import {Component, Input} from '@angular/core';
import {Proposal} from '../../../model/proposal/proposal';

@Component({
    selector: 'app-proposal-detail-international-program',
    templateUrl: './proposal-detail-international-program.component.html',
    standalone: false
})
export class ProposalDetailInternationalProgramComponent {
  @Input() proposal: Proposal;

}
